import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Cookie from 'js-cookie';
import { Config } from '../config/config';
import Menu from './Menu';
import Header from './Header';
import Footer from './Footer';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Navigate } from 'react-router-dom';
import { ApiGateWay } from '../ApiGateWay/ApiGateWay';
import Spinner from '../UIComponents/Spinner/Spinner';
import MessageBox from '../UIComponents/MessageBox/MessageBox';
import { Helmet } from 'react-helmet';
import CreateProjectDialog from '../pages/projectTracker/CreateProjectDialog';
import ProjectStatus from '../pages/projectTracker/ProjectStatus';

import UploadProjectInvoice from './projectTracker/UploadProjectInvoice';
import ViewInvoice from './ViewInvoice';
import LZString from 'lz-string';
import MessageBoxForInvalidPage from '../UIComponents/MessageBox/MessageBoxForInvalidPage';

class ProjectTracker extends Component {
  constructor(props) {
    super(props);
    const config = JSON.parse(Config);
    // let stores = JSON.parse(Cookie.get('stores'));
    // let wareHouses = JSON.parse(Cookie.get('warehouses'));
    let stores = JSON.parse(localStorage.getItem('storeData'));
    let wareHouses = JSON.parse(localStorage.getItem('warehouseData'));
    localStorage.removeItem('curStoreID');
    localStorage.removeItem('tabName');
    localStorage.removeItem('store_tabName');
    localStorage.removeItem('warehouse_tabName');
    const jsonData = Cookie.get('currentUser');
              let decompressedData = LZString.decompressFromBase64(jsonData);
          decompressedData = decompressedData =='\x00\x00\x00'?jsonData:decompressedData;
    const userInfo = JSON.parse(decompressedData) 
    const menu = userInfo['moduleAccess'];
    let userID = userInfo['userId'];
    let date = new Date();
    let month = ('0' + (date.getMonth() + 1)).slice(-2);
    let day = ('0' + date.getDate()).slice(-2);
    let year = date.getFullYear();
    var daynow = new Date();
    daynow.setDate(daynow.getDate());
    var dateStringNow = daynow.toISOString().split('T')[0];

    var dayst = new Date();
    dayst.setDate(dayst.getDate() - 30);
    var dateString = dayst.toISOString().split('T')[0];

    this.state = {
      menuLinks: config['menuItems'],
      title: 'Project Tracker',
      data: [],
      alert: '',
      incType: '',

      storeValue: '',
      storeSelected: false,
      closure: '',
      stores,
      userID: userID,
      wareHouses,
      wareHouseId: this.props.location.state
        ? this.props.location.state.id
        : '',
      modalOpen: false,
      visible: false,
      tableVisible: false,
      month: month,
      day: day,
      year,
      FromDate: dateString,
      ToDate: dateStringNow,

      codeJson: [],
      projectDetail: {},
      projectsDetails: [],
      submittedByCodeJson: [],
      loadProject: [],
      editing: false,
      invoiceEditing: false,
      invoiceOpen: false,
      pojectStat: [],
      invoiceStat: [],
      status: '',
      message: '',
      documentPath: '',
      apiInterface: config['api'],
      proxyjson: [],
      loading: false,
      submitted: false,
      submittedBy: '',
      projectStatusReport: '',
      user: menu,
      pageAllowed: false,
      status_up: false,
    };
  }

  handleStoreValue = (e) => {
    let wareHouseId = e.target.value;
    this.setState(() => ({
      wareHouseId: wareHouseId,
      visible: true,
      submitted: false,
      loadProject: [],
    }));
  };
  formatDate = (input) => {
    let input_date = input.toString();
    let datePart = input_date.split('-'),
      year = datePart[0], // get only two digits
      month = datePart[1],
      day = datePart[2];

    return day + '/' + month + '/' + year;
  };
  handleFromDate = (e) => {
    let frmD = e.target.value;

    this.setState(
      {
        FromDate: frmD,
      },

      function () {}
    );
  };

  handleToDate = (e) => {
    let toD = e.target.value;
    this.setState(
      {
        ToDate: toD,
      },
      function () {}
    );
  };

  handleSelect = () => {
    let storeId = this.state.wareHouseId;
    let fromDate = this.state.FromDate;
    let toDate = this.state.ToDate;

    this.setState({
      loading: true,
    });
    ApiGateWay.Get(
      this.state.apiInterface +
        '/loadProjects?storeId=' +
        storeId +
        '&fromDate=' +
        this.formatDate(fromDate) +
        '&toDate=' +
        this.formatDate(toDate)
    )
      .then((response) => response.json())
      .then((response) => {
        if (
          response.errorMessage === 'Token Expired' ||
          response.errorMessage === 'Invalid Token:::JWT expired' ||
          response.errorMessage ===
            'Your session has expired. Please login again.'
        ) {
          Cookie.remove('currentUser');
          Cookie.remove('stores');
          Cookie.remove('storesAll');
          Cookie.remove('warehouses');

          localStorage.clear();
          sessionStorage.clear();
          this.setState({
            loading: false,
            modalOpen: true,
            message:
              'Your session has been expired and you will be redirected to the login page!!',
          });
          setTimeout(() => {
            return (window.location = '/');
          }, 4000);
        }

        let response1 = response.projectInfo.sort(
          (a, b) => b.projectId - a.projectId
        );
        this.setState({
          loadProject: response1,
          status: response.status,
          visible: true,
          submitted: true,
          loading: false,
        });
      })

      .catch((error) => {
        this.setState({
          loading: false,
          modalOpen: true,
          message: 'Unable to retrieve the data. Please try again later',
        });
      });
  };

  setEditing = (x) => {
    this.setState({
      editing: x,
    });
  };
  setInvoiceEditing = (edor) => {
    this.setState({
      invoiceEditing: edor,
    });
  };
  setInvoiceViewer = (c) => {
    this.setState({
      invoiceOpen: c,
    });
  };

  handleProjectStatus = (details) => {
    this.setState({
      editing: true,
      invoiceOpen: false,
      invoiceEditing: false,
      pojectStat: details,
    });
  };

  handleUploadInvoice = (data) => {
    this.setState({
      invoiceEditing: true,
      editing: false,
      invoiceOpen: false,
      invoiceStat: data,
    });
  };
  handleViewInvoice = (insert) => {
    this.setState({
      loading: true,
    });
    ApiGateWay.Get(
      this.state.apiInterface +
        '/loadprojectinvoices?storeId=' +
        insert.storeId +
        '&projectId=' +
        insert.projectId
    )
      .then((response) => response.json())
      .then((response) => {
        this.setState({
          invoiceOpen: true,
          editing: false,
          loading: false,
          invoiceEditing: false,
          invoiceData: response.invoiceLink,
        });
        // alert(JSON.stringify(response.invoiceLink));
        // alert(JSON.stringify(insert));
      })
      .catch((error) => {
        this.setState({
          loading: false,
          modalOpen: true,
          message: 'Unable to retrieve the data. Please try again later!!',
        });
      });
  };
  handleInvoice = (invoiceNum, selectedFile, invoiceStat) => {
    let max = [];
    selectedFile.map((x, i) => {
      max.push({
        invoiceNumber: invoiceNum[i],
        invoicePath: x,
      });
    });
    //alert(JSON.stringify(max));
    this.setState({
      loading: true,
    });
    const invoiceDet = {
      invoiceCreatedBy: this.state.userID,
      invoiceDetails: max,
      projectId: invoiceStat.projectId,
      storeId: invoiceStat.storeId,
    };
    //alert(JSON.stringify(invoiceDet));

    ApiGateWay.Post(this.state.apiInterface + '/uploadInvoice', invoiceDet)
      .then((response) => response.json())
      .then((response) => {
        this.setState({
          loading: false,
          editing: false,
          invoiceEditing: false,
          // modalOpen: true,
          // message: 'Uploaded Successfully!!',
        });

        this.handleSelect();
        setTimeout(() => {
          toast.success('Invoice uploaded');
        }, 2000);
      })
      .catch((error) => {
        this.setState({
          loading: false,
          modalOpen: true,
          message: 'Unable to retrieve the data. Please try again later!!',
        });
      });
  };
  editStatusDetails = (pId, pStat) => {
    const pdata = {
      projectId: pId,
      projectStatus: pStat,
      updateUser: this.state.userID,
    };

    this.setState({
      loading: true,
    });

    ApiGateWay.Post(this.state.apiInterface + '/updateProjectStatus', pdata)
      .then((response) => response.json())
      .then((response) => {
        this.setState({
          loading: false,
          editing: false,
          invoiceEditing: false,
          status_up: true,
          // modalOpen: true,
          // message: 'Updated Successfully!!',
        });

        this.handleSelect();
        setTimeout(() => {
          toast.success('Status updated');
        }, 2000);
      })
      .catch((error) => {
        this.setState({
          loading: false,
          modalOpen: true,
          message: 'Unable to retrieve the data. Please try again later!!',
        });
      });
  };

  addProject = (projectName, projectSCope, duedate, id) => {
    let utc = 'T00:00:00.000Z';
    const project = {
      id: this.state.projectsDetails.length + 1,
      projectName: projectName,
      projectScope: projectSCope,
      createdBy: this.state.userID,
      createdDate: this.state.ToDate,
      wareHouseId: id,
    };
    let daynow = new Date();
    daynow.setDate(daynow.getDate());
    let dateStringNow = daynow.toISOString().split('T')[0];
    if (duedate === '') {
      duedate = dateStringNow;
    }
    const projects = {
      projectCreatedBy: this.state.userID,
      projectDetails: projectSCope,
      projectDueDate: duedate + utc,
      projectId: 0,
      projectName: projectName,
      storeId: id,
    };
    this.setState({
      loading: true,
    });

    ApiGateWay.Post(this.state.apiInterface + '/createProject', projects)
      .then((response) => response.json())
      .then(() => {
        this.setState({
          loading: false,
          //modalOpen: true,
          //message: 'Project Added Successfully!!',
        });
        this.handleSelect();
        setTimeout(() => {
          toast.success('Project Added Successfully');
        }, 2000);
      })
      .catch((error) => {
        this.setState({
          loading: false,
          modalOpen: true,
          message: 'Unable to retrieve the data. Please try again later!!',
        });
      });

    this.setState({
      projectDetail: project,
      projectsDetails: [...this.state.projectsDetails, project],
    });
  };

  componentDidMount() {
    let future = this.state.user;

    let pageAllow = false;

    future.map((val, index) =>
      val.value == 1
        ? !val.featureAccess
          ? val.featureName == 'Project Tracker'
            ? (pageAllow = true)
            : ''
          : ''
        : ''
    );
    if (pageAllow) {
      this.setState({
        pageAllowed: true,
        loading: true,
        visible: false,
      });

      const script = document.createElement('script');
      script.src = 'js/tabs.js';
      script.async = true;

      document.body.appendChild(script);
      setTimeout(() => {
        this.setState({
          loading: false,
        });
      }, 1000);

      ApiGateWay.PostEmp(this.state.apiInterface + '/fetchEmpInfo')
        .then((response) => response.json())
        .then((response) => {
          if (
            response.errorMessage === 'Token Expired' ||
            response.errorMessage === 'Invalid Token:::JWT expired' ||
            response.errorMessage ===
              'Your session has expired. Please login again.'
          ) {
            Cookie.remove('currentUser');
            Cookie.remove('stores');
            Cookie.remove('storesAll');
            Cookie.remove('warehouses');

            localStorage.clear();
            sessionStorage.clear();
            this.setState({
              loading: false,
              modalOpen: true,
              message:
                'Your session has been expired and you will be redirected to the login page!!',
            });
            setTimeout(() => {
              return (window.location = '/');
            }, 4000);
          }
          this.setState({
            submittedByCodeJson: response,
            visible: true,
            loading: false,
          });
        })
        .catch((error) => {
          this.setState({
            loading: false,
            modalOpen: true,
            message: 'Unable to retrieve the data. Please try again later',
          });
        });

      if (this.props.location.state) {
        ApiGateWay.Get(
          this.state.apiInterface +
            '/loadProjects?storeId=' +
            this.props.location.state.id +
            '&fromDate=' +
            this.props.location.state.fromDate +
            '&toDate=' +
            this.props.location.state.toDate
        )
          .then((response) => response.json())
          .then((response) => {
            if (
              response.errorMessage === 'Token Expired' ||
              response.errorMessage === 'Invalid Token:::JWT expired' ||
              response.errorMessage ===
                'Your session has expired. Please login again.'
            ) {
              Cookie.remove('currentUser');
              Cookie.remove('stores');
              Cookie.remove('storesAll');
              Cookie.remove('warehouses');

              localStorage.clear();
              sessionStorage.clear();
              this.setState({
                loading: false,
                modalOpen: true,
                message:
                  'Your session has been expired and you will be redirected to the login page!!',
              });
              setTimeout(() => {
                return (window.location = '/');
              }, 4000);
            }
            let response1 = response.projectInfo.sort(
              (a, b) => b.projectId - a.projectId
            );
            this.setState({
              loadProject: response1,
              status: response.status,
              visible: true,
              submitted: true,
              loading: false,
            });
          })
          .catch((error) => {
            this.setState({
              loading: false,
              modalOpen: true,
              message: 'Unable to retrieve the data. Please try again later',
            });
          });
      }
    } else {
      this.setState({
        pageAllowed: false,
        loading: true,
      });
    }
    //this.onLoad();
  }

  render() {
    const { loading, modalOpen, message, pageAllowed } = this.state;

    let addproject = [];
    if (this.state.loadProject) {
      addproject = this.state.loadProject.map((insert) => {
        return (
          <tr key={insert.projectId}>
            <td className='col-md-2 text-left'>
              {/* Link for project tracker*/}
                <Link to="/projectTracker/project" state={{ 
                               title: insert.projectId,
                               id: this.state.wareHouseId,
                               fromDate: this.formatDate(this.state.FromDate),
                               toDate: this.formatDate(this.state.ToDate),
                               projectStatusReport: insert.projectStatus,
                              }} >
                {insert.projectName}
              </Link>
            </td>
            <td className='text-left col-md-4'>{insert.projectDetails}</td>
            <td className='col-md-2'>{insert.projectCreatedBy}</td>
            <td className='col-md-1'>{insert.projectCreatedDate}</td>
            <td className='col-md-1'>{insert.projectDueDate}</td>
            <td className='col-md-1'>{insert.projectStatus}</td>
            <td className='col-md-1'>
              {insert.projectStatus === 'Completed' ? (
                <button
                  type='button'
                  className='btn btn-secondary deca-btn-yellow '
                  style={{
                    color: 'white',
                    textDecoration: 'none',
                  }}
                  disabled
                >
                  Update
                </button>
              ) : (
                <button
                  type='button'
                  className='btn btn-secondary deca-btn-yellow '
                  style={{
                    color: 'white',
                    textDecoration: 'none',
                  }}
                  onClick={() => this.handleProjectStatus(insert)}
                >
                  Update
                </button>
              )}
            </td>
            <td className='col-md-1'>
              {insert.projectStatus !== 'Work In Progress' ? (
                <button
                  type='button'
                  className='btn btn-secondary deca-btn-yellow '
                  style={{
                    color: 'white',
                    textDecoration: 'none',
                  }}
                  disabled
                >
                  Upload
                </button>
              ) : (
                <button
                  type='button'
                  className='btn btn-secondary deca-btn-yellow '
                  style={{
                    color: 'white',
                    textDecoration: 'none',
                  }}
                  onClick={() => this.handleUploadInvoice(insert)}
                >
                  Upload
                </button>
              )}
            </td>
            <td>
              {insert.invoiceLink === 'Y' ? (
                <a
                  type='button'
                  style={{ cursor: 'pointer' }}
                  onClick={() => this.handleViewInvoice(insert)}
                >
                  Click here
                </a>
              ) : (
                ''
              )}
            </td>
          </tr>
        );
      });
    } else {
      addproject.push(
        <tr>
          <td colSpan={9} className='text-center'>
            No Project Data
          </td>
        </tr>
      );
    }
    let future = this.state.user;

    let pageAllow = false;
    return (
      <>
        {future.map((val, index) =>
          val.value == 1
            ? !val.featureAccess
              ? val.featureName == 'Project Tracker'
                ? (pageAllow = true)
                : ''
              : ''
            : ''
        )}
        {pageAllow === false ? (
      
          <Navigate to="/pageNotAllowed" state={{ id:'Project Tracker' }} />
        ) : (
          ''
        )}
        <Helmet>
          <title>{this.state.title}</title>
        </Helmet>
        {modalOpen ? (
          <MessageBox
            message={message}
            signout={false}
            onClose={this.handleClose}
          />
        ) : null}

        <div className='wrapper'>
          <Header title={this.state.title} />

          <Menu />
          <div className='content-wrapper'>
            {loading ? (
              <Spinner />
            ) : (
              <section className='content' style={{ width: '95%' }}>
                <div className='row '>
                  <ToastContainer
                    position='top-right'
                    autoClose={2000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    className=''
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                  />
                  <div>
                    <form
                      className='form'
                      style={{ background: 'none', padding: '0% 0%' }}
                    >
                      <div className='row'>
                        <div className='form-group col-md-3 '>
                          <select
                            className='form-control'
                            value={this.state.wareHouseId}
                            onChange={this.handleStoreValue}
                          >
                            <option value='' disabled>
                              Select Warehouse
                            </option>

                            {this.state.wareHouses
                              .sort((a, b) =>
                                a.storeName > b.storeName ? 1 : -1
                              )
                              .map((val) => (
                                <option key={val.storeId} value={val.storeId}>
                                  {val.storeName}
                                </option>
                              ))}
                          </select>
                        </div>
                        <div
                          className='form-group col-md-3 '
                          style={{ marginLeft: '' }}
                        >
                          <input
                            value={this.state.FromDate}
                            onChange={this.handleFromDate}
                            type='date'
                            style={{ borderRadius: '7px' }}
                            className='form-control '
                          />
                        </div>
                        <div
                          className='form-group col-md-3  '
                          style={{ marginLeft: '' }}
                        >
                          <input
                            value={this.state.ToDate}
                            onChange={this.handleToDate}
                            type='date'
                            style={{ borderRadius: '7px' }}
                            className='form-control dashInput'
                          />
                        </div>

                        <div
                          className='form-group col-md-2'
                          style={{ marginLeft: '40px' }}
                        >
                          <button
                            type='button'
                            onClick={this.handleSelect}
                            className='btn btn-secondary deca-btn-yellow '
                            style={{}}
                          >
                            SUBMIT
                          </button>
                        </div>
                      </div>
                    </form>

                    {this.state.submitted &&
                    this.state.status === 'success' &&
                    this.state.visible ? (
                      <div
                        className='col-md-2'
                        style={{ marginBottom: '20px', marginLeft: '-15px' }}
                      >
                        <CreateProjectDialog
                          addProject={this.addProject}
                          wareHouseId={this.state.wareHouseId}
                        />
                      </div>
                    ) : (
                      ''
                    )}
                    {this.state.editing ? (
                      <ProjectStatus
                        editing={this.state.editing}
                        pojectStat={this.state.pojectStat}
                        setEditing={this.setEditing}
                        editStatusDetails={this.editStatusDetails}
                      />
                    ) : (
                      ''
                    )}
                    {this.state.invoiceEditing ? (
                      <UploadProjectInvoice
                        invoiceEditing={this.state.invoiceEditing}
                        invoiceStat={this.state.invoiceStat}
                        setInvoiceEditing={this.setInvoiceEditing}
                        handleInvoice={this.handleInvoice}
                      />
                    ) : (
                      ''
                    )}
                    {this.state.invoiceOpen ? (
                      <ViewInvoice
                        invoiceOpen={this.state.invoiceOpen}
                        invoiceData={this.state.invoiceData}
                        setInvoiceViewer={this.setInvoiceViewer}
                      />
                    ) : (
                      ''
                    )}
                  </div>

                  <div className='row' style={{ marginTop: '50px' }}>
                    <div className='col-md-12 backgr-custom'>
                      <table
                        className='table table-bordered table-hover table-striped '
                        style={{
                          borderCollapse: 'collapse',
                        }}
                      >
                        <thead
                          className=''
                          style={{
                            backgroundColor: '#3c8dbc',
                            color: '#fff',
                          }}
                        >
                          <tr style={{ textAlign: 'left' }}>
                            <th>Project Name</th>
                            <th>Project Scope</th>
                            <th>Created By</th>
                            <th>Created Date</th>
                            <th>Due Date</th>
                            <th>Project Status</th>
                            <th>Action</th>
                            <th>Upload Invoice</th>
                            <th>View Invoice</th>
                          </tr>
                        </thead>
                        <tbody className='mms text-center'>{addproject}</tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </section>
            )}
          </div>

          <Footer />
        </div>
      </>
    );
  }
}

export default ProjectTracker;
